<template>
  <div class="wl-your-prices mt-3" v-if="template">
    <div class="row" v-if="!viewMode">
      <div class="col col-lg-4">
        <b-form-group class="mb-2" label="Target margin:">
          <b-input-group size="sm">
            <b-form-input
              id="target-margin"
              type="text"
              placeholder="Target margin"
              v-model="target_margin"
            ></b-form-input>
            <b-input-group-append is-text> % </b-input-group-append>
            <b-input-group-append>
              <b-button
                size="sm"
                text="Button"
                @click="set_target_margin"
                variant="primary"
                >Set</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
    </div>

    <draggable v-model="template" handle=".group-handle" @end="update_order">
      <div class="wl-group" v-for="(group, index) in template" :key="index">
        <div class="row">
          <div class="col">
            <h5
              class="wl-group-header"
              :class="{ 'group-handle': editable }"
              v-if="group.name"
            >
              <svg
                class="bi"
                fill="currentColor"
                width="17px"
                height="17px"
                v-if="editable"
              >
                <use
                  xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrows-move"
                />
              </svg>
              {{ group.name }}
            </h5>
          </div>
        </div>
        <div class="w-100">
          <table class="table">
            <thead>
              <tr>
                <th v-if="editable"></th>
                <th>Description</th>
                <th>Case Size</th>
                <th>Invoice Price</th>
                <th>Menu / Shelf Price</th>
                <th>Profit</th>
                <th>Margin</th>
                <th v-if="editable"></th>
              </tr>
            </thead>
            <draggable
              v-model="group.items"
              tag="tbody"
              handle=".handle"
              @end="update_order"
            >
              <tr
                class="wl-data-table-row"
                v-for="item in group.items"
                :key="item.product._id"
                :class="{ 'opacity-1': item.hide }"
              >
                <td class="handle" v-if="editable">
                  <svg
                    class="bi my-1"
                    fill="currentColor"
                    width="18px"
                    height="18px"
                  >
                    <use
                      xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrows-move"
                    />
                  </svg>
                </td>
                <td>
                  <a :href="item.product._source.Permalink" target="_blank">{{
                    item.product._source.ItemDescription[0]
                  }}</a
                  ><br />
                  <small>LWIN: {{ item.item_code.substr(0, 7) }}</small>
                </td>
                <td>{{ item.product._source.CaseSize }}</td>
                <td class="wl-price-value-col">
                  {{ item.actual_price | currency }}
                </td>
                <td class="wl-price-input-col" v-if="!viewMode">
                  <b-input-group size="sm" prepend="£">
                    <b-form-input
                      type="tel"
                      size="sm"
                      no-wheel
                      debounce="500"
                      v-model.number.lazy="item.selling_price"
                      @input="make_dirty"
                      @change="update_selling_price(item.item_code, $event)"
                    ></b-form-input>
                  </b-input-group>
                </td>
                <td v-else>
                  {{ item.selling_price | currency }}
                </td>
                <td class="wl-price-value-col">
                  <span v-if="item.selling_price">{{
                    profit(item) | currency
                  }}</span>
                  <span v-else>N/A</span>
                </td>
                <td>
                  <span v-if="item.selling_price">{{
                    margin(item) | percentage
                  }}</span>
                  <span v-else>N/A</span>
                </td>
                <td v-if="editable">
                  <div class="wl-brochure-actions text-center">
                    <b-link
                      class="mb-1"
                      @click="
                        item.hide = !item.hide;
                        hide_item(item.item_code, item.hide);
                      "
                    >
                      <svg
                        class="bi"
                        fill="currentColor"
                        width="17px"
                        height="17px"
                      >
                        <use
                          xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#eye-slash"
                        />
                      </svg> </b-link
                    ><br />
                    <b-link
                      @click="
                        $emit('remove-item', { item_code: item.item_code })
                      "
                      ><svg
                        class="bi"
                        fill="currentColor"
                        width="17px"
                        height="17px"
                      >
                        <use
                          xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#x-square"
                        />
                      </svg>
                    </b-link>
                  </div>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import Draggable from "vuedraggable";

export default {
  components: {
    Draggable,
  },
  props: {
    value: {
      type: Array,
    },
    slug: {
      type: String,
    },
    presentationMode: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    targetMargin: {
      type: Number,
      default: 0,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    margin: () => (item) => {
      return (
        ((item.selling_price / 1.2 - item.actual_price) /
          (item.selling_price / 1.2)) *
        100
      );
    },
    profit: () => (item) => {
      return item.selling_price / 1.2 - item.actual_price;
    },
  },
  mounted() {
    this.data_incoming = true;
    this.template = JSON.parse(JSON.stringify(this.value));
    this.target_margin = this.targetMargin;
  },
  methods: {
    make_dirty() {
      this.dirty = true;
    },
    set_target_margin() {
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to set all prices based on a target margin of " +
            this.target_margin +
            "%?"
        )
        .then((state) => {
          if (state) {
            for (var i in this.template) {
              for (var j in this.template[i].items) {
                this.template[i].items[j].selling_price = (
                  (this.template[i].items[j].actual_price /
                    ((100 - this.target_margin) / 100)) *
                  1.2
                );

                this.template[i].items[j].selling_price = (Math.round(this.template[i].items[j].selling_price*20)/20).toFixed(2);

              }
            }

            this.$store.dispatch("winelist/save_margins", {
              id: this.slug,
              items: this.template,
              target_margin: this.target_margin,
            });
          }
        });
    },
    update_selling_price(item_code, selling_price) {
      this.$emit("update-item", {
        item_code,
        selling_price,
      });
      this.dirty = false;
    },
    hide_item(item_code, hide) {
      this.$emit("hide-item", {
        template: "PRICE",
        data: {
          item_code,
          hide,
        },
      });
    },
    update_order() {
      this.$emit("update-order", {
        template: "PRICE",
        data: {
          groups: this.template,
        },
      });
    },
  },
  watch: {
    targetMargin(val) {
      this.target_margin = val;
    },
    value: {
      deep: true,
      handler(val) {
        this.data_incoming = true;
        if (!this.dirty) {
          this.template = JSON.parse(JSON.stringify(val));
        }
      },
    },
    template: {
      deep: true,
      handler(val) {
        if (this.data_incoming) {
          this.data_incoming = false;
          return;
        }

        this.$emit("change", val);
      },
    },
  },
  data() {
    return {
      template: false,
      data_incoming: false,
      target_margin: "",
      dirty: false,
    };
  },
};
</script>
